import React, { useState } from "react";
import "./AccessLinkPageForm.scss";

import { AccessLinkPageFormButtons } from "./components/AccessLinkPageFormButtons/AccessLinkPageFormButtons";
import { AccessLinkPageInputField } from "./components/AccessLinkPageInputField/AccessLinkPageInputField";
import { RecruitmentFormButtons } from "./components/AccessLinkPageFormButtons/RecruitmentFormButtons";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { CustomInputLabel } from "src/app/components/CustomInput/CustomInput";
import { decodeRichText } from "src/app/Task/Comments/components/CommentText";
import { MetaFieldType } from "../../../../methods/getMetaFieldTypeOptions";

export function AccessLinkPageForm({
  metafields = [],
  wsWorkspaceUuid,
  setPageHandler,
  type,
  extensionUuid,
  contentGuidelines,
  integersOnly = false,
}) {
  const [values, setValues] = useState(
    metafields.map((field) => ({
      accessMode: field.accessMode,
      wsMetaFieldUuid: field.uuid,
      wsMetaFieldType: field.metaFieldOrigin,
      required: field.metaFieldIsRequired,
      isVirtualMetaField: field.isVirtualMetaField,
      wsMetaFieldName: field.name,
      value: field.value,
    })),
  );

  const isFormEditable =
    metafields.filter((m) => m.accessMode === "write").length > 0;

  const [errors, setErrors] = useState([]);
  const [submitDisabled, setSubmitDisabled] = useState(false);

  const dispatchValue = (
    accessMode,
    wsMetaFieldUuid,
    wsMetaFieldType,
    required,
    isVirtualMetaField,
    wsMetaFieldName,
    value,
  ) => {
    // check if wsMetaFieldUuid exist
    // if not append if to the end of vals
    const tempVals = values.filter(
      (v) => v.wsMetaFieldUuid !== wsMetaFieldUuid,
    );
    setValues([
      ...tempVals,
      {
        accessMode,
        wsMetaFieldUuid,
        wsMetaFieldType,
        required,
        isVirtualMetaField,
        wsMetaFieldName,
        value,
      },
    ]);
  };

  return (
    <div className="access-link-page__form">
      {contentGuidelines && (
        <div className="access-link-page__input-field">
          <div className="access-link-page__input-field-name-and-description">
            <CustomInputLabel
              aboveInput
              required
              className="access-link-page__input-field-label"
            >
              <IDHFormattedMessage
                id="ws_content_guidelines"
                defaultMessage="Content guidelines"
              />
            </CustomInputLabel>
          </div>
          <div className="value-field">
            <div className="access-link-page__input-field-content-guidelines">
              <span
                dangerouslySetInnerHTML={{
                  __html: decodeRichText(contentGuidelines),
                }}
              />
            </div>
          </div>
        </div>
      )}

      {metafields
        .filter((metafield) => metafield.type !== MetaFieldType.AiFileAnalysis)
        .map((metafield) => (
          <AccessLinkPageInputField
            key={metafield.uuid}
            metafield={metafield}
            globalValue={
              values.find((gv) => gv.wsMetaFieldUuid === metafield.uuid)?.value
            }
            dispatchValue={dispatchValue}
            wsWorkspaceUuid={wsWorkspaceUuid}
            errors={errors}
            setSubmitDisabled={setSubmitDisabled}
            formType={type}
            extensionUuid={extensionUuid}
            integersOnly={integersOnly}
          />
        ))}
      {isFormEditable &&
        (type === "recruitmentForm" ? (
          <RecruitmentFormButtons
            values={values}
            setValues={setValues}
            setPageHandler={setPageHandler}
            setErrors={setErrors}
            submitDisabled={submitDisabled}
          />
        ) : (
          <AccessLinkPageFormButtons
            values={values}
            setValues={setValues}
            setPageHandler={setPageHandler}
            setErrors={setErrors}
            submitDisabled={submitDisabled}
            integersOnly={integersOnly}
          />
        ))}
    </div>
  );
}
